import { SEWERAGE_SERVICES } from "../misc";
import { Category, CategoryEntity } from "./category.types";

export const getCategoryFromGQResult = (entities?: CategoryEntity[]): Category[] => {
    return (entities ?? []).map(
        ({
            comparisonGraphContent,
            comparisonInfoContent,
            comparisonTableContent,
            graphContent,
            infoContent,
            tableContent,
            parentId,
            ...rest
        }) => {
            const isSewerageServices = rest?.adminId?.indexOf(SEWERAGE_SERVICES) >= 0 ? true : false;

            return {
                isSewerageServices,
                comparisonGraphContent: comparisonGraphContent ?? [],
                comparisonInfoContent: comparisonInfoContent ?? [],
                comparisonTableContent: comparisonTableContent ?? [],
                graphContent: graphContent ?? [],
                infoContent: infoContent ?? [],
                tableContent: tableContent ?? [],
                catGraphContent: [],
                catInfoContent: [],
                catTableContent: [],
                parentId,
                ...rest
            };
        }
    );
};
